import React from 'react';
import PropTypes from 'prop-types';
import { AdminHeader } from '../components/AdminHeader';
import { isInIframe } from '../utils/deviceUtils';

const AdminLayout = ({ children, username, email, onLogout }) => {
  const embedded = isInIframe();

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {!embedded && (
        <AdminHeader
          username={username}
          email={email}
          onLogout={onLogout}
        />
      )}
      <main className={embedded ? 'flex-1' : 'flex-1 pt-[80px]'}>
        {children}
      </main>
    </div>
  );
};

AdminLayout.propTypes = {
  children: PropTypes.node.isRequired,
  username: PropTypes.string.isRequired,
  email: PropTypes.string,
  onLogout: PropTypes.func.isRequired,
};

export default AdminLayout;
